export var CommonEvents;
(function (CommonEvents) {
    CommonEvents["SAVE_OFFER"] = "save offer";
    CommonEvents["DESTROY"] = "destroy";
    CommonEvents["INITIALIZED"] = "initialized";
})(CommonEvents || (CommonEvents = {}));
export default CommonEvents;
//# sourceMappingURL=events.js.map